import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { setKeyCollection } from '../../actions/AppAction'
import { Menu, Dropdown, Icon } from 'antd'

export class ContextMenu extends Component {

  render() {
    const { children, menuItem, keyCollection } = this.props
    const filterMenuItem = (keyCollection && keyCollection === 'assetsPublicShared')
      ? menuItem.filter(f => f && f.text !== 'Grupos')
      : menuItem

    return (
      <React.Fragment>
        <Dropdown overlay={(<Menu>
          {filterMenuItem.map((r, k) => {
            if (r) {
              return <Menu.Item key={k} onClick={r.event}>
                <Icon type={r.icon} />{r.text}
              </Menu.Item>
            } else return null
          })}
        </Menu>)} trigger={['contextMenu']}>
          {children}
        </Dropdown>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return { keyCollectionStore: state.app.keyCollection }
}

const mapDispatchToProps = {
  setKeyCollection
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ContextMenu)))
